import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer data-testid="footer" style={{ background: '#1C1C1E', borderTop: '1px solid rgba(255,255,255,0.06)', padding: '50px 0 30px' }}>
      <div className="container-main">
        {/* Top: Logo + Locations */}
        <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1fr] gap-10 mb-10">
          {/* Brand */}
          <div>
            <img
              src="/qualiance-logo.png"
              alt="Qualiance International Limited"
              style={{ height: '52px', marginBottom: '12px', objectFit: 'contain' }}
            />
            <p className="font-body" style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.4)', lineHeight: 1.7 }}>
              Technical garment manufacturing engineered to Swiss military specifications. More than three decades of precision.
            </p>
          </div>

          {/* Corporate Office */}
          <div>
            <span className="font-mono block mb-3" style={{ fontSize: '0.6rem', color: '#C8102E', letterSpacing: '0.15em', textTransform: 'uppercase', fontWeight: 600 }}>
              Corporate Office
            </span>
            <p className="font-body" style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.8 }}>
              406 - B Wing, Knox Plaza,<br />
              Mindspace, Malad West,<br />
              Mumbai 400064, INDIA.
            </p>
            <p className="font-body mt-2" style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.8 }}>
              Tel: <a href="tel:+912242666003" style={{ color: 'rgba(255,255,255,0.7)' }}>+91 22 42666003</a><br />
              Email: <a href="mailto:info@qualiance.com" style={{ color: 'rgba(255,255,255,0.7)' }}>info@qualiance.com</a>
            </p>
          </div>

          {/* Factory */}
          <div>
            <span className="font-mono block mb-3" style={{ fontSize: '0.6rem', color: '#C8102E', letterSpacing: '0.15em', textTransform: 'uppercase', fontWeight: 600 }}>
              Factory
            </span>
            <p className="font-body" style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.8 }}>
              Door. No: 5/491-R, Lakshmi Nagar,<br />
              Vengamedu, Angeripalayam Road,<br />
              Chettipalayam Village, Tiruppur 641603,<br />
              Tamil Nadu, INDIA.
            </p>
            <p className="font-body mt-2" style={{ fontSize: '0.8rem', color: 'rgba(255,255,255,0.5)', lineHeight: 1.8 }}>
              Tel: <a href="tel:+918098001128" style={{ color: 'rgba(255,255,255,0.7)' }}>+91 8098001128 / 29 / 30 / 31</a>
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
          <div className="flex items-center gap-4">
            <p className="font-mono" style={{ fontSize: '0.55rem', color: 'rgba(255,255,255,0.2)', letterSpacing: '0.1em' }}>
              &copy; {new Date().getFullYear()} Qualiance International Limited. All rights reserved.
            </p>
            <Link to="/investor-relations" className="font-mono inline-flex items-center gap-2 transition-colors" style={{ fontSize: '0.6rem', color: '#C8102E', letterSpacing: '0.1em', textDecoration: 'none', textTransform: 'uppercase', border: '1px solid rgba(200,16,46,0.3)', padding: '5px 14px', borderRadius: '4px' }} data-testid="footer-investor-relations">
              Investor Relations
            </Link>
          </div>
          <div className="flex flex-wrap gap-2">
            {['Military & Defense', 'Technical Outerwear', 'Corporate Wear', 'Workwear & PPE', 'Activewear', 'Sun-Protective', 'Hi-Visibility'].map((cat, i) => (
              <span key={i} className="font-mono" style={{ fontSize: '0.5rem', letterSpacing: '0.08em', textTransform: 'uppercase', border: '1px solid rgba(255,255,255,0.08)', padding: '3px 8px', borderRadius: '3px', color: 'rgba(255,255,255,0.25)' }}>
                {cat}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
